// src/pages/Login.js
import React, { useState } from "react";
import { supabase } from "../supabaseClient";
import { routes } from "../routes";
import bcrypt from "bcryptjs";

export default function LoginPage({ onNavigate, onLoggedIn, brandLogo = "/logo-ancla.svg" }) {
  const [correo, setCorreo] = useState("");
  const [contrasena, setContrasena] = useState("");
  const [mostrarPass, setMostrarPass] = useState(false);
  const [loading, setLoading] = useState(false);
  const [logoOk, setLogoOk] = useState(true);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // 1) Buscar cliente
      const { data: cli, error } = await supabase
        .from("clientes")
        .select("id, nombre, correo, contrasena_hash, activo")
        .eq("correo", correo)
        .limit(1)
        .single();

      if (error || !cli) {
        alert("Correo o contraseña incorrectos.");
        setLoading(false);
        return;
      }
      if (cli.activo === false) {
        alert("Tu cuenta está inactiva. Contáctanos para activarla.");
        setLoading(false);
        return;
      }

      // 2) Validar contraseña
      const ok = await bcrypt.compare(contrasena, cli.contrasena_hash);
      if (!ok) {
        alert("Correo o contraseña incorrectos.");
        setLoading(false);
        return;
      }

      // 3) Persistir sesión y navegar
      const user = { id: cli.id, nombre: cli.nombre, correo: cli.correo };
      onLoggedIn?.(user);
      onNavigate?.(routes.home);
    } catch (err) {
      console.error(err);
      alert("Error inesperado al iniciar sesión.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="bg-gray-50 px-4 sm:px-6 lg:px-8">
      {/* bloque superior con logo y título (deja ver el footer) */}
      <div className="max-w-md mx-auto pt-8 pb-20">
     

        {/* Card */}
        <div className="mt-6 bg-white/90 backdrop-blur rounded-2xl shadow-xl border border-gray-100 p-6 sm:p-8">
          <h1 className="text-2xl sm:text-3xl font-extrabold text-center text-gray-900">
            Inicia sesión en <span className="text-[#5A61E5]">El Ancla CR</span>
          </h1>

          <form onSubmit={handleSubmit} className="mt-6 space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Correo</label>
              <input
                type="email"
                value={correo}
                onChange={(e) => setCorreo(e.target.value)}
                required
                className="w-full rounded-lg border-gray-300 focus:border-[#5A61E5] focus:ring-[#5A61E5] px-3 py-2"
                placeholder="tu@correo.com"
                autoComplete="email"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Contraseña</label>
              <div className="relative">
                <input
                  type={mostrarPass ? "text" : "password"}
                  value={contrasena}
                  onChange={(e) => setContrasena(e.target.value)}
                  required
                  className="w-full rounded-lg border-gray-300 focus:border-[#5A61E5] focus:ring-[#5A61E5] px-3 py-2 pr-12"
                  placeholder="••••••••"
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  onClick={() => setMostrarPass((v) => !v)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-sm font-medium text-[#5A61E5] hover:underline"
                >
                  {mostrarPass ? "Ocultar" : "Mostrar"}
                </button>
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-[#5A61E5] text-white py-3 rounded-lg font-semibold hover:bg-[#4349c6] transition-colors disabled:opacity-70"
            >
              {loading ? "Ingresando…" : "Ingresar"}
            </button>
          </form>

          <p className="text-center text-sm text-gray-600 mt-5">
            ¿No tienes cuenta?{" "}
            <button
              onClick={() => onNavigate?.(routes.registro)}
              className="text-[#5A61E5] font-semibold hover:underline"
            >
              Regístrate
            </button>
          </p>
        </div>
      </div>
    </section>
  );
}
